module.exports = {
    siteUrl: `https://www.orcamoney.com`, // Site domain. Do not include a trailing slash!

    postsPerPage: 9, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

    siteTitleMeta: `Whole of market direct lending investment services`, // This allows an alternative site title for meta data for pages.
    siteDescriptionMeta: `We provide research, capital deployment, risk management and reporting services to institutional investors looking to invest in the European direct lending market.  Discover the best opportunities in direct lending with Orca.`, // This allows an alternative site description for meta data for pages.

    shareImage: `/images/orca-avatar.png`, // fallback image for meta data. Will be used, when no post/tag/author image specified. 1200x1200 is recommended
    shareImageWidth: 1000, // Change to the width of your default share image
    shareImageHeight: 523, // Change to the height of your default share image

    shortTitle: `Orca`, // Used for App manifest e.g. Mobile Home Screen
    siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
    backgroundColor: `#FFFFFF`, // Used for Offline Manifest
    themeColor: `#2853EA` // Used for Offline Manifest
};
